import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/api/client";
import { sessionRevision } from "@/lib/session-request-scope";
import { transitionSession } from "@/lib/session-transition";

export function useDeleteAccount(onDeleted?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => api.delete("me"),
    onSuccess: (_data, _variables, _result, context) => {
      const revision = sessionRevision();
      transitionSession(queryClient, null, context);
      if (sessionRevision() === revision + 1) onDeleted?.();
    },
  });
}
